import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

// The bare URL has no page of its own (an empty outlet), so land on the 401(k) insight, whose own guard redirects further.
export default class AuthenticatedSyfInsightsIndexRoute extends Route {
  @service declare router: RouterService;

  redirect() {
    this.router.replaceWith('authenticated.syf.insights.four-oh-one-k');
  }
}
